import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, FlexCenter, HideScrollbar, LineClamp } from '../../global/commonStyle';
interface Props {
  isLoading?: boolean;
  updateSpacing?: boolean;
}
const Main = styled.div`
  position: relative;
  max-width: 1022px;
  height: calc(100dvh - 83px);
  margin: var(--space-0) auto;
  ${HideScrollbar}
  &.desktop-your-time-log-content-empty {
    height: calc(100dvh - 61px);
  }
  padding-inline: var(--space-24);
  ${mobile_xl(css`
    padding-inline: var(--space-20);
    height: 100dvh;
    &.desktop-your-time-log-content-empty {
      height: 100dvh;
    }
  `)}
`;

const Header = styled.div<Props>`
  max-width: 1022px;
  margin-inline: auto;
  padding: var(--space-10) var(--space-24) ${(props) => (props.updateSpacing ? 'var(--space-12)' : 'var(--space-0)')};
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-14);
  background: var(--background-secondary);
  z-index: var(--z-index-header);
  ${mobile_xl(css`
    width: calc(100vw - 40px);
    padding: var(--space-8) var(--space-20) var(--space-8) var(--space-20);
    margin: var(--space-0) -20px;
    flex-direction: column;
    gap: var(--space-24);
    align-items: flex-start;
    position: relative;
  `)}
`;

const HeaderTopSection = styled.div`
  ${FlexBetween}
  ${mobile_xl(css`
    flex-direction: column;
    gap: var(--space-20);
  `)}
`;
const LeftDiv = styled.div`
  ${FlexCenter}
  gap: var(--space-8);
  ${mobile_xl(css`
    gap: var(--space-12);
  `)}
`;
const RightDiv = styled.div`
  ${FlexCenter}
  gap: var(--space-10);
  .dropdown-icon {
    transform: rotate(180deg);
  }
  ${mobile_xl(css`
    flex-direction: column;
    align-items: flex-start;
    width: calc(100vw - 40px);
    .custom-dropdown {
      width: 100%;
    }
  `)}
`;
const HeaderText = styled.div`
  ${Typography.heading_md}
  color: var(--text-primary);
`;

const TopHeader = styled.div`
  ${FlexBetween}
  ${mobile_xl(css`
    width: 100%;
    gap: var(--space-20);
  `)}
`;

const Text = styled.div`
  ${Typography.body_md}
  color: var(--text-primary);
`;
const Export = styled.div`
  ${AlignCenter}
  ${Typography.body_md_medium}
  color: var(--brand-primary);
  cursor: pointer;
`;
const MainContent = styled.div`
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-12);
  background: var(--background-primary);
  display: flex;
  flex-direction: column;
  margin-bottom: var(--space-24);
  box-shadow: var(--shadow-modal);
  ${mobile_xl(css`
    margin-block: var(--space-8) var(--space-96);
  `)}
`;

const FirstContent = styled.div`
  ${FlexBetween}
  gap: var(--space-80);
  padding: var(--space-12) var(--space-16) var(--space-11);
  border-bottom: 0.5px solid var(--border-primary);
  :last-child {
    border-bottom: none;
  }
  ${mobile_xl(css`
    padding: var(--space-12);
    gap: var(--space-24);
  `)}
`;
const TopicTitle = styled.h2`
  ${Typography.body_lg_medium}
  color: var(--text-primary);
  margin: var(--space-0);
  ${mobile_xl(css`
    max-width: 218px;
    width: 100%;
    ${LineClamp(1)}
  `)}
`;
const TopicDescription = styled.p`
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: var(--space-0);
  ${mobile_xl(css`
    max-width: 218px;
    width: 100%;
    ${LineClamp(1)}
    word-break: break-all;
  `)}
`;
const LeftContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  ${mobile_xl(css`
    max-width: 218px;
    gap: var(--space-4);
  `)}
`;
const RightContent = styled.div`
  ${AlignCenter}
  .lock-icon:hover {
    background-color: unset;
  }
`;
const TimeTitle = styled.p`
  ${Typography.body_md}
  margin: var(--space-0);
  color: var(--brand-primary);
  span {
    color: var(--brand-primary);
    white-space: nowrap;
    ${Typography.body_lg}
  }
`;

const BorderDiv = styled.div`
  border-left: 0.5px solid var(--border-primary);
  height: 24px;
  width: 1px;
  margin-inline: var(--space-12) var(--space-8);
`;
const HeaderRightContent = styled.div`
  position: relative;
  ${FlexCenter}

  .custom-dropdown {
    border-color: var(--border-primary);
    border-radius: var(--border-radius-8) var(--border-radius-0) var(--border-radius-0) var(--border-radius-8);
    width: max-content;

    ${mobile_xl(css`
      width: unset;
    `)}
  }
  .calendar-dropdown {
    border-color: var(--border-primary);
    border-radius: var(--border-radius-0) var(--border-radius-8) var(--border-radius-8) var(--border-radius-0);
    width: max-content;
    box-shadow: var(--top-right-border), var(--bottom-border);
    &:hover {
      box-shadow: var(--top-right-border), var(--bottom-border);
    }
    ${mobile_xl(css`
      width: unset;
      p {
        width: 100%;
        text-align: left;
      }
    `)}
  }
  ${mobile_xl(css`
    max-width: calc(100vw - 40px);
    display: grid;
    grid-template-columns: 0.93fr 1.07fr;
    width: 100%;
  `)}
`;

const BottomData = styled.div<Props>`
  height: 100%;
  ${HideScrollbar}
  ${(props: Props) =>
    props.isLoading &&
    css`
      opacity: 0.8;
      cursor: default;
      pointer-events: none;
    `}
`;

const DateDropBox = styled.div<Props>`
  position: absolute;
  right: 0;
  max-width: min-content;
  background: var(--background-primary);
  border-radius: var(--border-radius-8);
  border: 0.5px solid var(--border-primary);
  padding: var(--space-0);
  margin-top: var(--space-5);
  z-index: var(--z-index-99);

  .react-calendar__navigation {
    margin-bottom: var(--space-10);
  }
  .react-calendar__navigation button {
    background: none;
    ${Typography.body_lg_semibold}
    height: 20px;
    margin-top: var(--space-0);
    padding-inline: var(--space-3);
  }
  .react-calendar__tile--now:enabled:hover,
  .kKROaE .react-calendar__tile--now:enabled:focus {
    border-radius: var(--border-radius-full);
  }
  .rdrStartEdge .rdrEndEdge {
    color: var(--brand-primary) !important;
  }
  .menuStyle {
    box-shadow: none;
    padding: var(--space-0);
    display: flex;
    flex-direction: column;
    .menuitem {
      white-space: nowrap;
      overflow: hidden;
      display: block;
      text-overflow: ellipsis;
    }
  }
  .rdrMonth .rdrDayDisabled {
    background-color: var(--background-primary);
  }
  .rdrCalendarWrapper {
    background-color: var(--background-primary);
    border-radius: var(--border-radius-8);
  }
  .rdrDayNumber span {
    color: var(--text-primary);
  }
  .rdrDayPassive .rdrDayNumber span {
    color: var(--text-secondary);
  }
  .rdrWeekDay {
    color: var(--text-secondary);
  }
  .rdrDay {
    color: var(--text-secondary) !important ;
  }

  .rdrDateDisplayWrapper {
    background-color: var(--background-primary);
    border-radius: var(--border-radius-8);
  }
  .rdrDateDisplayItem input {
    background-color: var(--background-primary);
    border: 0.5px solid var(--border-primary);
    color: var(--text-primary);
    border-radius: var(--border-radius-4);
  }
  .rdrDateDisplayItem {
    background-color: var(--background-primary);
    box-shadow: none;
  }
  .rdrMonthAndYearPickers select:hover {
    background-color: var(--neutral-secondary);
  }
  .rdrMonthAndYearPickers select {
    color: var(--text-primary);
  }
  .rdrDateDisplay {
    color: transparent !important ;
  }
  .rdrNextPrevButton {
    background-color: var(--neutral-secondary);
  }
  .rdrStartEdge {
    color: var(--text-secondary) !important;
  }
  .rdrInRange {
    color: var(--text-secondary) !important;
  }
  .rdrEndEdge {
    color: var(--text-secondary) !important;
  }
  .rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span,
  .rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span,
  .rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span,
  .rdrDay:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span {
    color: var(--background-primary);
  }

  .rdrDayToday:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span:after,
  .rdrDayToday:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span:after,
  .rdrDayToday:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span:after,
  .rdrDayToday:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span:after {
    background-color: var(--background-primary);
  }
  .rdrNextButton i {
    border-color: transparent transparent transparent var(--text-primary);
  }
  .rdrPprevButton i {
    border-color: transparent var(--text-primary) transparent transparent;
  }
  ${(props) =>
    props.isLoading &&
    css`
      opacity: 0.8;
      cursor: default;
      pointer-events: none;
    `}
`;

const ItemMainDiv = styled.div`
  max-width: 154px;
  min-width: 154px;
  width: 100%;
  ${mobile_xl(css`
    max-width: calc(100vw - 34px);
  `)}
`;
export {
  Main,
  Header,
  LeftDiv,
  RightDiv,
  HeaderText,
  TopHeader,
  Text,
  Export,
  MainContent,
  FirstContent,
  LeftContent,
  TopicTitle,
  TopicDescription,
  RightContent,
  TimeTitle,
  BorderDiv,
  HeaderRightContent,
  BottomData,
  DateDropBox,
  ItemMainDiv,
  HeaderTopSection
};
